export const normalizeVarKey = (key) =>
  String(key || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const buildRecords = ({ rows = [], mapping = {}, template = {}, existingIds }) => {
  const required = (template.required || []).map(normalizeVarKey);
  const defaults = template.defaults || {};
  const uniqueKey = normalizeVarKey(
    template.uniqueKey || required[0] || 'respondent_id'
  );

  const existing = new Set(
    (existingIds instanceof Set ? Array.from(existingIds) : existingIds || []).map((v) =>
      String(v).trim()
    )
  );

  const seenInBatch = new Set();
  const records = [];
  const skipped = [];
  const errors = [];
  const stats = {
    total: rows.length,
    ready: 0,
    skippedDuplicate: 0,
    skippedExisting: 0,
    errored: 0,
  };

  rows.forEach((row) => {
    const variables = {};
    Object.entries(mapping).forEach(([varName, sourceCol]) => {
      if (!sourceCol) return;
      const raw = row[sourceCol];
      if (raw === undefined || raw === null) return;
      const value = String(raw).trim();
      if (value === '') return;
      variables[normalizeVarKey(varName)] = value;
    });

    Object.entries(defaults).forEach(([key, value]) => {
      const k = normalizeVarKey(key);
      if (variables[k] === undefined || variables[k] === '') variables[k] = value;
    });

    const missing = required.filter((k) => !variables[k]);
    if (missing.length > 0) {
      stats.errored += 1;
      errors.push({ row, reason: `Missing required: ${missing.join(', ')}` });
      return;
    }

    const keyValue = String(variables[uniqueKey] || '').trim();
    if (existing.has(keyValue)) {
      stats.skippedExisting += 1;
      skipped.push({ row, reason: `${uniqueKey} already saved` });
      return;
    }
    if (seenInBatch.has(keyValue)) {
      stats.skippedDuplicate += 1;
      skipped.push({ row, reason: `Duplicate ${uniqueKey} within this file` });
      return;
    }
    seenInBatch.add(keyValue);

    records.push({ respondent_id: keyValue, variables, row_data: row });
    stats.ready += 1;
  });

  return { records, skipped, errors, stats };
};
